
import { MessageInstance } from "antd/es/message/interface";
import { ModalStaticFunctions } from "antd/es/modal/confirm";
import { NotificationInstance } from "antd/es/notification/interface";


let message: MessageInstance;
let modal: Omit<ModalStaticFunctions, "warn">;
let notification: NotificationInstance;


export const setGlobalStatic = (
    msg: MessageInstance,
    mod: Omit<ModalStaticFunctions, "warn">,
    notif: NotificationInstance
) => {
    message = msg;
    modal = mod;
    notification = notif;
};


export { message, modal, notification };

